<template>
	<div class="page-gallery scrollable only-y ">
    <title-component/>
    <content-component/>
	</div>
</template>
<script>
import TitleComponent from './Title.vue'
import ContentComponent from './Content.vue'
export default {
  components: { TitleComponent, ContentComponent },
};
</script>

<style lang="css" scoped>
.page-header {
  margin-bottom: 10px !important;
}
</style>
